<script>
    import { client, gql } from "../../GraphQL.svelte";
    import { allProjectFields } from "../../Participaid.svelte";
    import ProjectField from "../../models/participaid/ProjectField.js";
    import Project from "../../models/participaid/Project.js";

    import Dialog from "../Dialog.svelte";
    import Emoji from "../Emoji.svelte";
    import LoadingSpinner from "../LoadingSpinner.svelte";
    import LoadingModal from "../LoadingModal.svelte";
    import ProjectFieldDefinition from "../participaid/ProjectFieldDefinition.svelte";
    import ProjectFieldSelectionList from "../participaid/ProjectFieldSelectionList.svelte";
    import ProjectSummary from "../participaid/ProjectSummary.svelte";

    import Paper, {Title, Subtitle, Content} from '@smui/paper';
    import Button, {Label} from '@smui/button';
    import FaIcon from 'fa-svelte'
    import DataTable, {Head, Body, Row, Cell} from '@smui/data-table';
    import Tab, {Icon} from '@smui/tab';
    import TabBar from '@smui/tab-bar';
    import { faPlus } from '@fortawesome/free-solid-svg-icons/faPlus'
    import { createEventDispatcher } from 'svelte';
    import { fade } from 'svelte/transition';

    // TODO: wrap into some kind of standardized eventbus
    const dispatch = createEventDispatcher();

    export let show;
    export let showActions;
    export let projectId;
    export let isOwner;
    export let isLive;
    export let settled;
    export let closed;

    let fields = [];
    let project;
    let activeRequest;
    let goLiveErrMsg = "";

    let fieldsLoaded = false;
    let projectLoaded = false;

    const iconTabs = [
        {
            icon: 'emoji_people',
            label: 'Summary'
        },
        {
            icon: 'assignment',
            label: 'Fields'
        },
    ];

    export let activeTab = iconTabs[0];

    $: if (projectId && !fields.length && !fieldsLoaded) {
        activeRequest = allProjectFields(projectId)
            .then(res => {
                console.log(`[ProjectFieldsDialog2] loaded fields`);
                fields = res.data.projectFields;
                fieldsLoaded = true;})
            .then(_ => client.query({
                query: gql`
                    query($id: Guid!) {
                        project(id: $id) {
                            id,
                            administrationPeriodType,
                            companySharePercentage,
                            companySharePrice,
                            companyValuation,
                            description,
                            settlementDateTarget,
                            stockCalculationStrategy,
                            title,
                            visibilityTeam,
                            company {
                                name
                            }
                        }
                    }
                `,
                variables: {
                    id: projectId
                }
            }))
            .then(res => {
                console.log(`[ProjectFieldsDialog2] loaded project data`);
                project = res.data.project;
                projectLoaded = true;
            })
            .catch(err => {
                console.log(`[ProjectFieldsDialog2] there was an error: ${err}`);
            });
    }

    $: editable = isOwner;
    $: hasFields = fields && fields.length;

    console.log(`[ProjectFieldsDialog] initialising...`);

    function goLive() {
        activeRequest = Project.goLive(projectId)
            .then(goConfetti)
            .then(res => {
                dispatch("live");
            })
            .catch(err => goLiveErrMsg = "There was an error going live. Try again later")
    }

    function goPause() {
        // TODO
    }

    function handleDelete(evt) {
        let deletedField = evt.detail;
        // ...
    }

    // CONFETTI

    const count = 200;
    const defaults = {
      origin: { y: 0.7 }
    };

    function fire(particleRatio, opts) {
      return confetti(Object.assign({}, defaults, opts, {
        particleCount: Math.floor(count * particleRatio)
      }));
    }

    // https://www.kirilv.com/canvas-confetti/
    function goConfetti() {
        fire(0.25, {
          spread: 26,
          startVelocity: 55,
        });
        fire(0.2, {
          spread: 60,
        });
        fire(0.35, {
          spread: 100,
          decay: 0.91,
        });
        fire(0.1, {
          spread: 120,
          startVelocity: 25,
          decay: 0.92,
        });
        return fire(0.1, {
          spread: 120,
          startVelocity: 45,
        });
    }

</script>

<svelte:head>
    <script src="https://cdn.jsdelivr.net/npm/canvas-confetti@1.2.0/dist/confetti.browser.min.js"></script>
</svelte:head>

<Dialog {show} request={activeRequest} width={700} style="min-width: 400px; max-width: 90vw;" class="project-fields-dialog">
    <span slot="title">Agreements</span>
    <span slot="messages">{goLiveErrMsg}</span>

    <!--  TODO: refactor into component  -->
    {#if isLive}
        <div style="padding: 10px; margin-bottom: 20px; text-align: center; font-weight: bold; background: yellow; collor: brown;">
            Note: the PartiPie is live. Any field adjustments will be announced to all participants for transparency
        </div>
    {/if}

    <TabBar tabs={iconTabs} let:tab bind:active={activeTab} style="max-width: 900px; margin: auto; margin-bottom: 50px;">
        <Tab {tab}>
            <Icon class="material-icons">{tab.icon}</Icon>
            <Label>{tab.label}</Label>
        </Tab>
    </TabBar>

    {#if activeTab == iconTabs[0]}
        {#if projectLoaded}
            <ProjectSummary
                name={project.title}
                companyName={project.company.name}
                visibilityTeam={project.visibilityTeam}
                administrationPeriodType={project.administrationPeriodType}
                endDate={project.settlementDateTarget}
                companySharePercentage={project.companySharePercentage}
                companySharePrice={project.companySharePrice}
                companyValuation={project.companyValuation}
                stockCalculationStrategy={project.stockCalculationStrategy}
                {fields}
                showFields={false}
            />
        {:else}
            loading...
        {/if}
    {:else}
        <ProjectFieldSelectionList
                {editable}
                saveable
                {projectId}
                showTemplates={false}
                bind:fields
                on:save={() => {}}
            on:deleteAll={() => fields = []}
            on:delete={handleDelete}
        />
    {/if}

    {#if !isOwner}
        <!-- contributos cannot edit -->
    {:else if isLive}
<!--        <Button on:click={goPause} style="padding: 25px 0; width: 100%; margin-top: 25px; background-color: #c00; color: white; font-weight: bold; font-size: 20px;">-->
<!--            <span class="icon" style="font-size: 30px;"></span> Pause-->
<!--        </Button>-->
<!--        <small style="color: #ccc; text-align: center; font-size: 10px; display: block;">-->
<!--            after pausing the project, input by team members cannot be accepted or reviewed anymore-->
<!--        </small>-->
    {:else if !closed && !settled}
        <Button class="project-fields-dialog-live-button" on:click={goLive} disabled={!hasFields} style="padding: 25px 0; width: 100%; margin-top: 25px; color: white; font-weight: bold; font-size: 20px;">
            <span class="icon" style="font-size: 30px;">🚀 </span> GO LIVE
        </Button>
        <small style="color: #ccc; text-align: center; font-size: 10px; display: block;">
            after going 'live' with the Partipie, you may still adjust the fields, but contributors will be notified of your adjustments
        </small>
    {/if}
</Dialog>

<style>
    h2 {
        text-align: center;
    }

    :global(.project-fields-dialog .project-fields-dialog-live-button) {
        background-color: #2cd533;
    }

    :global(.project-fields-dialog .project-fields-dialog-live-button[disabled]) {
        background-color: #DDD;
    }
</style>